interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  onGoBack?: () => void;
  retryLabel?: string;
  backLabel?: string;
}

export function ErrorState({
  message,
  onRetry,
  onGoBack,
  retryLabel = '再試行',
  backLabel = 'マニュアルTOPへ戻る',
}: ErrorStateProps) {
  return (
    <div className="manual-error">
      <h2>エラー</h2>
      <p>{message}</p>
      {(onRetry || onGoBack) && (
        <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          {onRetry && (
            <button className="manual-back-button" onClick={onRetry}>
              {retryLabel}
            </button>
          )}
          {onGoBack && (
            <button className="manual-back-button" onClick={onGoBack}>
              {backLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
